const { objectOperator } = require('../agent/utils/spread');
const commons = require('./commons');
const {
  FCP, LCP, FID, CLS, TBT, INP,
  DNS_LOOKUP_TIME, DOWNLOAD_TIME, FETCH_TIME,
  HEADER_SIZE, TTFB, TOTAL_TIME,
  WORKER_TIME, REDIRECT_COUNT,
  DOM_COMPLETE, DOM_INTERACTIVE, DOM_CONTENT_LOADED_END, DOM_CONTENT_LOADED_START, DOM_CONTENT_LOADED,
  ONLOAD_END, ONLOAD_START, ONLOAD,
  REQUEST_START, RESPONSE_START, RESPONSE_END, RESPONSE_TIME,
  NAVIGATION_TYPE, INITIAL_CONTENT_SIZE, REDUCED_MOTION, REDUCED_COLOR,
  DEBUG_TARGET_LCP, DEBUG_TARGET_CLS, DEBUG_TARGET_FID, DEBUG_TARGET_INP,
} = require('./metrics');

const metrics = [
  FCP, LCP, FID, CLS, TBT, INP,
  DNS_LOOKUP_TIME, DOWNLOAD_TIME, FETCH_TIME,
  HEADER_SIZE, TTFB, TOTAL_TIME,
  WORKER_TIME, REDIRECT_COUNT,
  DOM_COMPLETE, DOM_INTERACTIVE, DOM_CONTENT_LOADED_END, DOM_CONTENT_LOADED_START, DOM_CONTENT_LOADED,
  ONLOAD_END, ONLOAD_START, ONLOAD,
  REQUEST_START, RESPONSE_START, RESPONSE_END, RESPONSE_TIME,
  NAVIGATION_TYPE, INITIAL_CONTENT_SIZE, REDUCED_MOTION, REDUCED_COLOR,
  DEBUG_TARGET_LCP, DEBUG_TARGET_CLS, DEBUG_TARGET_FID, DEBUG_TARGET_INP,
];

module.exports = objectOperator({ commons, metrics });
